<div class="scene-container">

  <picture class="scene-image-wrapper">
    <source media="(min-aspect-ratio: 1/1)"
            srcset="assets/animation_login_page/background_city_with_mountains_without_clouds_format_for_desktop.webp"
            type="image/webp">
    <img src="assets/animation_login_page/background_city_with_mountains_without_clouds.webp"
         alt=""
         class="scene-image"/>
  </picture>

  <div class="cloud-layer">
    <img src="assets/animation_login_page/cloud_1.webp" alt="" class="cloud cloud-a">
    <img src="assets/animation_login_page/cloud_2.webp" alt="" class="cloud cloud-b">
    <img src="assets/animation_login_page/cloud_3.webp" alt="" class="cloud cloud-c">
    <img src="assets/animation_login_page/cloud_2.webp" alt="" class="cloud cloud-d">
    <img src="assets/animation_login_page/cloud_1.webp" alt="" class="cloud cloud-e">
  </div>

  <div class="road-layer">
    <div class="bike-wrapper">
      <div class="speed-lines">
        <span class="speed-line speed-line-1"></span>
        <span class="speed-line speed-line-2"></span>
        <span class="speed-line speed-line-3"></span>
        <span class="speed-line speed-line-4"></span>
      </div>
      <span class="exhaust-puff puff-1"></span>
      <span class="exhaust-puff puff-2"></span>
      <span class="exhaust-puff puff-3"></span>
      <img src="assets/animation_login_page/keremet_car.webp" alt="" class="bike car">
      <img src="assets/animation_login_page/wheel.webp" alt="" class="wheel wheel-back">
      <img src="assets/animation_login_page/wheel.webp" alt="" class="wheel wheel-front">
    </div>
  </div>

  <div class="scene-content">

    <div class="logo-section">
      <div class="logo-backdrop"></div>
      <div class="logo-frost-glow"></div>
      <img src="assets/images/white-keremet-logo.png" alt="Logo" class="logo-winter">
    </div>

    <div class="ice-form-container">
      <form class="winter-form" (ngSubmit)="login()">

        <div class="ice-field-group">
          <div class="ice-label">
            <span class="label-text">Логин</span>
            <div class="label-frost"></div>
          </div>

          <div class="ice-input-container">
            <div class="ice-glass-layer"></div>

            <input type="text"
                   pInputText
                   [(ngModel)]="username"
                   name="username"
                   class="ice-input"
                   placeholder="Введите логин"
                   autocomplete="off">
          </div>
        </div>

        <div class="ice-field-group">
          <div class="ice-label">
            <span class="label-text">Пароль</span>
            <div class="label-frost"></div>
          </div>

          <div class="ice-input-container">
            <div class="ice-glass-layer"></div>

            <p-password [(ngModel)]="password"
                        name="password"
                        [feedback]="false"
                        [toggleMask]="true"
                        placeholder="Введите пароль"
                        styleClass="ice-password-field">
            </p-password>
          </div>
        </div>

        <div class="ice-checkbox-group">
          <p-checkbox [(ngModel)]="rememberMe"
                      name="rememberMe"
                      [binary]="true"
                      inputId="rememberMe"
                      styleClass="ice-checkbox">
          </p-checkbox>
          <label for="rememberMe" class="checkbox-label">Запомнить меня</label>
        </div>

        <div class="ice-button-container">
          <div class="button-ice-layer"></div>
          <div class="button-glow"></div>
          <div class="button-frost-border"></div>

          <button type="submit" class="ice-button">
            <span class="button-text">Войти</span>
          </button>
        </div>

      </form>
    </div>
  </div>
</div>
